import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import PopupOverview from '../Popup/PopupOverview';
import s from './HistoryParameters.css';
import HistoryParameterRow from './HistoryParameterRow';
import { getDataSoftener, getDataSuperior } from './HistoryMessages';
import HistoryParametersFilterbox from './HistoryParametersFilterbox';
import HistoryParametersHeader from './HistoryParametersHeader';
import Loader from '../Loader';

class HistoryParametersView extends React.Component {

  getHeader = (
    deviceDocument,
    softenerFilterDocument,
    superiorFilterDocument,
  ) => {
    const deviceType = deviceDocument.get('deviceType');
    let data = [];
    let filter = null;
    switch (deviceType) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        data = getDataSoftener();
        filter = softenerFilterDocument;
        break;
      case 'superior':
        data = getDataSuperior();
        filter = superiorFilterDocument;
        break;
      default:
        break;
    }

    return (
      <tr>{data.map((item, index) => this.showBox(item, index, filter, deviceType))}</tr>
    );
  };

  showBox = (item, index, filter, deviceType) => {
    const value = filter.get(item.name);
    if (+value === 1) {
      switch (deviceType){
        case 'softener':
        case 'charlie':
        case 'simplex':
          return (
            <th className={cx(s.row_container, s.header_color)} key={index}>
              <FormattedMessage {...item.text} />
            </th>
          );
        case 'superior':
          return (
            <th 
              className={cx(s.row_container, s.spirotech_header_color)} 
              key={index}
            >
              <FormattedMessage {...item.text} />
            </th>
          );
        default:
          return null;
      }
    }
    return null;
  };

  onClick = () => {

  }

  render() {
    const {
      deviceDocument,
      documentSoftenerFilter,
      documentSuperiorFilter,
      deviceDocumentPaging
    } = this.props;
    const rowsData = deviceDocument && deviceDocument.get('rowsData');
    const requestInProgress = deviceDocument && deviceDocument.get(
      'requestInProgress',
    );
    if (
      deviceDocument !== 'undefined' &&
      deviceDocument.get('serial') !== null &&
      +deviceDocument.get('documentType') === 2) {
      if (!requestInProgress && rowsData) {
        return (
          <PopupOverview
            className={s.Popup__editdevice}
            onClose={this.props.onClose}
            deviceType={deviceDocument.get('deviceType')}
            overrideOnClose
          >
            <HistoryParametersFilterbox
              documentSoftenerFilter={documentSoftenerFilter}
              documentSuperiorFilter={documentSuperiorFilter}
              deviceDocument={deviceDocument}
            />
            <HistoryParametersHeader
              onSave={this.props.onSavePDF}
              onClearFilter={this.props.onClearFilter}
              deviceType={deviceDocument.get('deviceType')}
              deviceName={deviceDocument.get('deviceName')}
              deviceSerial={deviceDocument.get('serial')}
              deviceDocumentPaging={deviceDocumentPaging}
            />
            <table className={s.Table_container}>
              <thead>
                {this.getHeader(
                  deviceDocument,
                  documentSoftenerFilter,
                  documentSuperiorFilter,
                )}
              </thead>
              <tbody>
                {rowsData.map((row, index) => (
                  <HistoryParameterRow
                    row={row}
                    key={index}
                    documentSoftenerFilter={documentSoftenerFilter}
                    documentSuperiorFilter={documentSuperiorFilter}
                    deviceType={deviceDocument.get('deviceType')}
                    onClick={this.onClick}
                  />
                ))}
              </tbody>
            </table>
          </PopupOverview>
        );
      }
      return (
        <PopupOverview
          className={s.Popup__editdevice}
          onClose={this.props.onClose}
          overrideOnClose
        >
          <Loader block />
        </PopupOverview>
      );
    }
    return null;
  }
}

HistoryParametersView.propTypes = {
  deviceDocument: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSoftenerFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSuperiorFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onClose: PropTypes.func.isRequired,
  onSavePDF: PropTypes.func.isRequired,
  deviceDocumentPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onClearFilter: PropTypes.func.isRequired,
};

export default withStyles(s)(HistoryParametersView);



// WEBPACK FOOTER //
// ./src/components/HistoryParameters/HistoryParametersView.js